import { Routes, Route } from 'react-router-dom';
import { ROICalculator } from './Components/ROICalculator/ROICalculator';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<ROICalculator />} />
    </Routes>
  );
};

export default App;